/**
 * Locale Configuration Constants - SINGLE ENTRY POINT for locale constants - "barrel file").
 * Re-exports static constants, derived constants, and RMS default data.
 * No circular dependency: this file does not import from locale-config.types.
 */

export { DEFAULT_RMS_REGION_DATA } from './rms-data'

export {
  LOCALE_COOKIE,
  REGION_DETAILS_LOCAL_STORAGE_KEY,
  LOCALE_FORMAT,
  LOCALE_FORMAT_STANDARD,
  DEFAULT_LOCALE,
  DEFAULT_LANGUAGE,
  DEFAULT_LOCALE_PREFIX,
  FALLBACK_REGION_ID,
  LOCALE_STANDARD_FORMAT,
  LOCALE_STANDARD_FORMAT_CANADA,
  LOCALE_STANDARD_FORMAT_CANADA_FRENCH,
  KLARNA_REGION_WISE_CLIENT_ID_CONFIG,
  LANGUAGE_CODE,
  COUNTRY_CODE,
} from './locale-config.static-constants'

export {
  SUPPORTED_COUNTRIES,
  COUNTRY_CURRENCIES,
  COUNTRY_LANGUAGES,
  DEFAULT_COUNTRY,
  formatLocale,
  FALLBACK_LOCALE,
  COUNTRY_CONFIG,
  ECOUNTRIES,
  EDD_WRAPPING_LOCALES,
  EDD_WRAPPING_DESKTOP_EXCLUSIONS,
  EDD_CUTOFF_WRAP_LOCALES,
} from './locale-config.derived-constants'
